import React from "react";
import { css } from "aphrodite";
import { styles } from "./YearPickerStyles";

interface IYearPickerProps {
    selectedStartYear: number;
    selectedEndYear: number;
    isStartYear: boolean;
    onYearSelected: (year: number)=>void
}

class YearPickerState {
    public readonly currentIndex: number = 0;
}

export class YearPicker extends React.Component<IYearPickerProps, YearPickerState> {

    constructor(props: IYearPickerProps){
        super(props);
        this.state = new YearPickerState();
    }

    public render() {
        return (
            <div id="year_picker" className={css(styles.container)} >
                <div id="slider" className={css(styles.slider)}  >
                    <div id="back" className={css(styles.button)} onClick={this.onBackClick} >
                        Back
                    </div>
                    <div id="selected_year"className={css(styles.selectedYearItem)} onClick={this.onDateClick} >
                        {this.props.selectedStartYear}
                    </div>
                    <div id="forward" className={css(styles.button)} onClick={this.onNextClick}>
                        Next
                    </div>
                </div>
                <div id="years" className={css(styles.years)} >
                    {this.buildYears(this.state.currentIndex)}
                </div>
            </div>
        );
    }

    private onDateClick = (event: any) => {
        this.setState({...this.state, currentIndex: 0})
    }

    private onBackClick = (event: any) => {
        this.setState({...this.state, currentIndex: this.state.currentIndex - 1})
    }

    private onNextClick = (event: any) => {
        this.setState({...this.state, currentIndex: this.state.currentIndex + 1})
    }

    private buildYears = (index: number) => {
        let startyear : number ;
        
        if(this.props.isStartYear){
            startyear = this.props.selectedStartYear + (12*index);
        }else{
            startyear = this.props.selectedEndYear + (12*index);
        }
        const years = [];
        for(let i : number = 0;i<12;i++){
            years.push(startyear + (+i));
        }
        return (
            <React.Fragment>
                {years.map(this.buildYearItem)}
            </React.Fragment>
        );
    }

    private buildYearItem = (year: number, index: number) => {

        let style;
        if(year === this.props.selectedStartYear){
            style = {
                color: "#3c86fc"
            }
        }else{
            if(this.props.isStartYear){
                if((year < this.props.selectedStartYear && (this.props.selectedEndYear - year > 10)) || (year > this.props.selectedEndYear) ){
                    style = {
                        color: "#bfbfbf"
                    }
                }else{
                    style = {
                        color: "#606060"
                    }
                }                
            }else{
                if((year < this.props.selectedStartYear) || (year - this.props.selectedStartYear > 10)){
                    style = {
                        color: "#bfbfbf"
                    }
                }else{
                    style = {
                        color: "#606060"
                    }
                }
            }
            
        }
        
        return (
            <div key={index} className={css(styles.yearItem)} style={style} onClick={(event: any)=>{this.props.onYearSelected(year)}}>
                {year}
            </div>
        )
    }


}


// WEBPACK FOOTER //
// ./src/components/YearPicker.tsx